module.exports = __webpack_public_path__ + "static/img/DrivingForce_logo_2017_200px_old.921aa5a.png";